{
  "instances": {
    "loggers": {
      "label": "Annálsritarar",
      "application": "Forrit",
      "fetch_failed_some_instances": "Mistókst að sækja annálsritara fyrir {failed} af {count} eintökum. Stillingin þeirra annálsritara mun hugsanlega mistakast.",
      "filter": {
        "class_only": "bara klasar",
        "configured": "stillt"
      },
      "instance": "Eintak",
      "new": "nýtt",
      "no_loggers_found": "Fundið engar annálsritarar.",
      "unset": "Núllstilla",
      "setting_loglevel_failed": "Stilla {logger} á {loglevel} mistekist."
    }
  }
}
